<template>

  <div>

    <ChecklistModelActivityDialog
        v-if="dialogModalActivityFormShow"
        @onClose="dialogModalActivityFormShow = false"
        @onSubmit="onSubmitActivityForm"
        :model-activity="dialogModelActivityForm"

    />

    <t-msg info v-if="items.length === 0 && pageFormIsLoaded">Atividades são formulários adicionais que podem ser
      obrigatórios ou não para finalização do checklist. Para implementar é necessário acessar os Modelos de Inspeção,
      informando quais as atividades adicionais deseja realizar. Este recurso somente estará disponível mediante a
      customização junto a Onlaine.
    </t-msg>


    <t-form-list v-else :generalErrors="generalErrors" :items="items" :fields="fields" :command="command"
                 :user-auth="userAuth"
                 :status="status"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 disable-default-buttons
                 title-items="Atividades"
                 hide-header
                 disable-footer-length
                 primary-key-column="checklistActivityId"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">


      <template #list-content="{item}">

        <b-col cols="12">

          <b-row class="mt-1 link d-flex" @click="openActivityForm(item)">

            <div class="card-title mr-2">{{ item.name }}</div>
            <div>
              <b-badge v-if="objValid(item.finishDate)" variant="success">PREENCHIDA</b-badge>
              <b-badge v-else variant="warning">PENDENTE</b-badge>
            </div>


          </b-row>

        </b-col>

      </template>

    </t-form-list>


  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"
import pageListMixin from "@/mixins/page/pageListMixin";
import ChecklistModelActivityDialog from "@/views/modules/checklist/Checklist/ChecklistModelActivityDialog";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageListMixin, pageFormListMixin],
  components: {tFormList, ChecklistModelActivityDialog},
  name: 'ChecklistEnvironment',
  data() {
    return {
      path: "checklist/model-activity", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "checklistId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "checklistActivityId", keyDelete: "checklistActivityId"},
        {key: "environmentCodeLabel", label: "Cód. Amb.", cols: "3"},
        {key: "name", label: "Atividade", cols: "3"},
        {key: "status", label: "Status", cols: "4"},
      ],
      form: {
        checklistId: this.foreignKey,
        checklistActivityId: 0,
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        code: "",
      },
      dialogModalActivityFormShow: false,
      dialogModelActivityForm: {},
    }
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()


    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()


    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.checklistActivityId)

    },

    mountedList() {

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    openActivityForm(item) {

      this.dialogModalActivityFormShow = true
      this.dialogModelActivityForm = item
      this.openModal("modal-checklist-activity-form-detail")

    },

    async onSubmitActivityForm(){
      ui.toast(this, "Atividade salva", this.dialogModelActivityForm.name + " preenchido com sucesso!")
      await this.getList()
    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
